import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import mainStore from 'src/stores/main';
import { useConfig } from 'src/hooks/config';
import Money from 'src/common/components/money';
import { getBetCalculations } from 'calculation';
import upperDataStore from 'src/stores/upperData';
import selectionStore from 'src/stores/selections';
import { useTranslation } from "src/hooks/translation";
import { BetCalculationsEnum } from 'src/constants/enums/betCalculations';

interface IProps {
  stake: number;
};

const BetDetailsTaxOnReturnOrProfit = ({ stake }: IProps) => {
  const t = useTranslation();
  const config = useConfig();
  const { partnerConfig } = useRecoilValue(upperDataStore);
  const { betType } = useRecoilValue(mainStore);
  const { selections } = useRecoilValue(selectionStore);
  const { bonusRules, currencyConfig } = useRecoilValue(upperDataStore);

  const filtredBonusRules = bonusRules.filter(item => !item.ExactLosing);

  const { profitOrReturnTax } = useMemo(() => getBetCalculations([
    BetCalculationsEnum.TaxForReturnOrProfit
  ], {
    config,
    stake,
    events: selections,
    betType,
    partnerConfig,
    bonusRule: filtredBonusRules,
    currencyConfig,
  }), [config, stake, betType, currencyConfig, filtredBonusRules, selections, partnerConfig])

  if (!profitOrReturnTax) return null;

  return (
    <div className="B-betslip-bet-details-info-row">
      <p className="B-info-row-title">
        {t('Tax on Return:')}
      </p>
      <p className="B-info-row-number"><Money amount={profitOrReturnTax} /></p>
    </div>
  );
};

export default BetDetailsTaxOnReturnOrProfit;
